<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="40" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">拆 卸</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="15" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">principle</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">更 换</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="31" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Assemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">版 本</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="46" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Type</textPath>
                            </text>
                          </g>
                          <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                          rx: 椭圆X轴半径
                          ry: 椭圆Y轴半径
                          xr: 椭圆旋转角度
                          laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                          sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                          x: 终点X轴坐标
                          y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
                    <div
                      v-for="(item,index) in downObj"
                      :key="index"
                      :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                      @click="downAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'outer'">
                    <div
                      v-for="(item,index) in outerObj"
                      :key="index"
                      :class="[{'active':outerActive === item.id}, 'app-submenu-item']"
                      @click="outerAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'
    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    export default {
        components: {
            Loader,
            Nav,
            language,
        },
        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                is_hidenote:true,

                downActive:null, //当前选项2下标
                outerActive:null,//当前选项3下标
                modelanimationList:[], //动画列表
                selectobject: '', //当前选择的选项
                settimeoutList:[],
                tweenplane:[],
                localPlanelv: new THREE.Plane(new THREE.Vector3(0, 1, 0), -25.3),
                localPlanehuan1: new THREE.Plane(new THREE.Vector3(0, 0, 1), -20),

                lang: 'cn', // 语言
                downObj: [ //下模选项
                  {
                    id: 0,
                    text: '全开镶块', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    show_name:["dk","bk"],
                    animate_number: '3',
                  },
                  {
                    id: 1,
                    text: '半开镶块', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    show_name:["dk","bk"],
                    animate_number: '0',
                  },
                  {
                    id: 2,
                    text: '堵块', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    show_name:["dk","bk"],
                    animate_number: '2',
                  },
                ],
                outerObj: [ //下模选项
                  {
                    id: 0,
                    text: 'ABA', //菜单显示
                    en_text: 'ABA', //菜单显示(英文)
                    show_name:["lv","huan1"],//显示
                    transparent_name:["z1"],
                  },
                  {
                    id: 1,
                    text: 'ABC', //菜单显示
                    en_text: 'ABC', //菜单显示(英文)
                    hide_name:["z1"],//隐藏
                    show_name:["lv","lan","huan2","z2"],//显示
                    transparent_name:["z2"],
                  },
                  {
                    id: 2,
                    text: 'AB', //菜单显示
                    en_text: 'AB', //菜单显示(英文)
                    hide_name:["z1"],//隐藏
                    show_name:["lv","lan","z2"],//显示
                    transparent_name:["z2"],
                  },
                ],
            }
        },
        mounted: function () {
          let _this = this;
          _this.initCanvas();
          _this.timer = setInterval(function() {
              if ( !_this.hadLoaded ) {
                  if ( _this.loadprogress < 80 ) {
                      _this.loadprogress += 0.8;
                  } else if ( _this.modelLoaded ) {
                      if ( _this.loadprogress <= 100 ) {
                          _this.loadprogress += 2;
                      } else {
                          _this.hadLoaded = true;
                          clearInterval(_this.timer);
                          _this.timer = null;
                      }
                  }
              }
          }, 20);
          window.addEventListener("resize", _this.onResize, false);
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },
        methods: {
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;
              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true,
                  // 设置对数深度缓冲区，优化深度冲突问题
                  logarithmicDepthBuffer: true
              });
              _this.renderer.sortObjects = false; //(物体的渲染顺序将会由他们添加到场景中的顺序所决定) 关闭自定义顺序，也就是按照默认排序。 决定是材质先后起作用还是添加到场景的先后起作用
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
          },
          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },
          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 15, 75);
            _this.camera.lookAt(_this.scene.position);
          },
          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enableZoom = true;
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();
              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/fpq/fpq-2.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.modelanimationList = gltf.animations
                _this.model.scale.set(0.4, 0.4, 0.4);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.animate();

                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })
                _this.initmodel()
                _this.initlocalPlane()
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },
          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
              // _this.labelRenderer.setSize(_this.containerW, _this.containerH);
          },
          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },
          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            this.resetSetTimeOut()
            this.downActive = null
            this.outerActive = null
            this.initlocalPlane()
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            this.initmodel()
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
            }else{
              this.toobarActive = e;
              switch (e) {
                case 'upper':
                  this.upperAnimate()
                  break;
                case 'down':
                  _this.stopclip(0)
                  _this.ShowHideComponents(["bk","dk"],true)
                  break;
                default:
                  break;
              }
            }
          },
          stopclip(number){ //停在模型动画时间轴上的任意时间
            let _this = this
            const mixer = new THREE.AnimationMixer(_this.model);
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = mixer.clipAction(_this.modelanimationList[0]); //创建动画clipAction对象
            // 设置动画播放的起始时间和结束时间
            _this.clipAction.paused = true;//暂停状态拖动拖动条
            _this.clipAction.time = number //物体状态为动画第number秒对应状态
            // }, item.animationend);
            _this.clipAction.play(); //播放动画
            //不循环播放
            _this.clipAction.loop = THREE.LoopOnce;
            // 物体状态停留在动画结束的时候
            _this.clipAction.clampWhenFinished = true;
            // 如果想播放动画,需要周期性执行`mixer.update()`更新AnimationMixer时间数据
            const clock = new THREE.Clock();
            function loop() {
              requestAnimationFrame(loop);
              //clock.getDelta()方法获得loop()两次执行时间间隔
              const frameT = clock.getDelta();
              // 更新播放器相关的时间
              mixer.update(frameT);
            }
            loop();

          },
          /**
           * @description 菜单选项1
           * @param {number} e 菜单选项对象
           */
          upperAnimate: function() {
            let _this = this;
            this.initmodel()
            this.resetSetTimeOut()
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            _this.settimeoutList.push(
              setTimeout(() => {
                _this.ShowHideComponents(["dcls"],true)
              }, 1800)
            )
            if(_this.tweenplane.length != 0){
              for (let i = 0; i < _this.tweenplane.length; i++) {
                _this.tweenplane[i].stop()
              }
              _this.tweenplane.length = 0
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[1]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: -50,
              y: 15,
              z: 75,
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          downAnimate: function(item) {
            let _this = this;
            this.downActive = item.id
            this.selectobject = item
            this.initmodel()
            this.resetSetTimeOut()
            if(item.hide_name){//隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(item.show_name){//显示
              _this.ShowHideComponents(item.show_name,true)
            }
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.tweenplane.length != 0){
              for (let i = 0; i < _this.tweenplane.length; i++) {
                _this.tweenplane[i].stop()
              }
              _this.tweenplane.length = 0
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          outerAnimate: function(item) {
            let _this = this;
            this.outerActive = item.id
            this.selectobject = item
            this.initmodel()
            this.resetSetTimeOut()
            this.initlocalPlane()
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.hide_name){//隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(item.show_name){//显示
              _this.ShowHideComponents(item.show_name,true)
            }
            if(item.transparent_name){//透明
              _this.transparentComponents(item.transparent_name,0.5)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
            if(_this.tweenplane.length != 0){
              for (let i = 0; i < _this.tweenplane.length; i++) {
                _this.tweenplane[i].stop()
              }
              _this.tweenplane.length = 0
            }
            switch (item.id) {
              case 0:
                _this.tweenplane[0] = new TWEEN.Tween(_this.localPlanelv).to({constant: 26.7}, 6000);
                _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanehuan1).to({constant: -3.85}, 2000);
                _this.tweenplane[1].onComplete(function () {
                  _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanehuan1).to({normal:{x:-1,y:1,z:0},constant:-3}, 300);
                  _this.tweenplane[1].start();
                  _this.tweenplane[1].onComplete(function () {
                    _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanehuan1).to({normal:{x:0,y:1,z:0},constant:-3}, 400);
                    _this.tweenplane[1].start();
                    _this.tweenplane[1].onComplete(function () {
                      _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanehuan1).to({normal:{x:0,y:1,z:0},constant:26.7}, 3300);
                      _this.tweenplane[1].start();
                    })
                  })
                })
                _this.tweenplane[0].start();
                _this.tweenplane[1].start();
                break;
              case 1:
                _this.tweenplane[0] = new TWEEN.Tween(_this.localPlanelv).to({constant: 26.7}, 6000);
                _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({constant: -3.85}, 2000);
                _this.tweenplane[1].onComplete(function () {
                  _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({normal:{x:-1,y:1,z:0},constant:-3}, 300);
                  _this.tweenplane[1].start();
                  _this.tweenplane[1].onComplete(function () {
                    _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({normal:{x:0,y:1,z:0},constant:-3}, 400);
                    _this.tweenplane[1].start();
                    _this.tweenplane[1].onComplete(function () {
                      _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({normal:{x:0,y:1,z:0},constant:26.7}, 3300);
                      _this.tweenplane[1].start();
                    })
                  })
                })

                _this.tweenplane[2] = new TWEEN.Tween(_this.localPlanehuan2).to({constant: -3.85}, 2000);
                _this.tweenplane[2].onComplete(function () {
                  _this.tweenplane[2] = new TWEEN.Tween(_this.localPlanehuan2).to({normal:{x:1,y:1,z:0},constant:-3}, 300);
                  _this.tweenplane[2].start();
                  _this.tweenplane[2].onComplete(function () {
                    _this.tweenplane[2] = new TWEEN.Tween(_this.localPlanehuan2).to({normal:{x:0,y:1,z:0},constant:-3}, 400);
                    _this.tweenplane[2].start();
                    _this.tweenplane[2].onComplete(function () {
                      _this.tweenplane[2] = new TWEEN.Tween(_this.localPlanehuan2).to({normal:{x:0,y:1,z:0},constant:26.7}, 3300);
                      _this.tweenplane[2].start();
                    })
                  })
                })

                _this.tweenplane[0].start();
                _this.tweenplane[1].start();
                _this.tweenplane[2].start();
                break;
              case 2:
                _this.tweenplane[0] = new TWEEN.Tween(_this.localPlanelv).to({constant: 26.7}, 6000);
                _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({constant: -3.85}, 2000);
                _this.tweenplane[1].onComplete(function () {
                  _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({normal:{x:-1,y:1,z:0},constant:-3}, 300);
                  _this.tweenplane[1].start();
                  _this.tweenplane[1].onComplete(function () {
                    _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({normal:{x:0,y:1,z:0},constant:-3}, 400);
                    _this.tweenplane[1].start();
                    _this.tweenplane[1].onComplete(function () {
                      _this.tweenplane[1] = new TWEEN.Tween(_this.localPlanelan).to({normal:{x:0,y:1,z:0},constant:26.7}, 3300);
                      _this.tweenplane[1].start();
                    })
                  })
                })

                _this.tweenplane[0].start();
                _this.tweenplane[1].start();
                break;
              default:
                break;
            }
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 显示所有组件
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.depthWrite = true
                object.material.opacity = 1
              }
            })
          },
          /**
           * @description 隐藏所有组件
           */
          hideallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              if(object.isMesh){
                object.visible = false
              }
            })
          },
          /**
           * @description 透明组件/取消透明
           * @param {array} e 透明名列表
           * @param {number} e （透明度）
           * @param {Boolean} e （0透明）or（1取消透明）
           */
          transparentComponents(objectArray,opcity,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              console.log(objectArray);
              console.log(objectArray.length);
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  // _this.model.getObjectByName(objectArray[i]).material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                  // _this.model.getObjectByName(objectArray[i]).material.color.set("#222")
                  _this.model.getObjectByName(objectArray[i]).material.depthWrite = false
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    // _this.model.getObjectByName(objectArray[i]).children[j].material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                    // _this.model.getObjectByName(objectArray[i]).children[j].material.color.set("#222")
                    _this.model.getObjectByName(objectArray[i]).children[j].material.depthWrite = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = true
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          //初始化状态
          initmodel(){
            let _this = this
            _this.showallcomponents()
            _this.ShowHideComponents(["lv","lan","huan1","huan2","z2","dk","bk","dcls"],false)
          },
          /**
           * @description 重置所有计时器
           */
          resetSetTimeOut(){
            let _this = this;
            if(_this.settimeoutList.length != 0){
              for (let i = 0; i < _this.settimeoutList.length; i++) {
                clearInterval(_this.settimeoutList[i])
              }
              _this.settimeoutList.length = 0
            }
          },
          /**
           * @description 重置所有平面剖面
           */
          initlocalPlane(){
            let _this = this
            _this.localPlanelv = new THREE.Plane(new THREE.Vector3(0, 1, 0), -25.3)
            _this.model.getObjectByName("lv").material.clippingPlanes = [_this.localPlanelv];

            _this.localPlanehuan1 = new THREE.Plane(new THREE.Vector3(-1, 0, 0), -18.5) // start 18.5  to4
            _this.model.getObjectByName("huan1").material.clippingPlanes = [_this.localPlanehuan1];

            _this.localPlanelan = new THREE.Plane(new THREE.Vector3(-1, 0, 0), -22.4) // start 18.5  to4
            _this.model.getObjectByName("lan").material.clippingPlanes = [_this.localPlanelan];

            _this.localPlanehuan2 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -22.4) // start 18.5  to4
            _this.model.getObjectByName("huan2").material.clippingPlanes = [_this.localPlanehuan2];

            // _this.helper = new THREE.PlaneHelper( _this.localPlanehuan2, 100, 0xffe374 );
            // _this.scene.add( _this.helper );
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // _this.transparentComponents(["lg"],0.3)
            console.log(_this.model.getObjectByName("z1"),"z1");
            console.log(_this.model.getObjectByName("z2"),"z2");
            console.log(_this.model.getObjectByName("lv"),"lv");
            console.log(_this.model.getObjectByName("huan1"),"huan1");
            console.log(_this.model.getObjectByName("huan2"),"huan2");
            console.log(_this.model.getObjectByName("lan"),"lan");
            // console.log(_this.model.getObjectByName("LV"),"LV");
            // for (let i = 1; i < 7; i++) {
            //   console.log(_this.model.getObjectByName("HG"+i),"HG"+i);
            // }
            // for (let i = 1; i < 4; i++) {
            //   console.log(_this.model.getObjectByName("HX"+i),"HX"+i);
            // }
          },
        },


    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/fpqmodel.vue